export function getSelectIndex(selectRows, row) {
	for (let i = 0; i < selectRows.length; i++) {
		const item = selectRows[i];
		if (item === row || (!!item.id && item.id === row.id)) return i
	}
	return -1
}